import { element } from 'protractor';
import { ConteudoService } from './../../../service/caixa/conteudo.service';
import { CaixaModel } from './../../../model/caixa/caixa.model';
import { CaixaService } from './../../../service/caixa/caixa.service';
import { ActivatedRoute } from '@angular/router';
import { Component, ElementRef, OnDestroy, OnInit } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { EventEmitterService } from 'app/service/event-emitter-service';
import * as BWIPJS from 'bwip-js';

@Component({
  selector: 'app-relatorio-caixa',
  templateUrl: './relatorio-caixa.component.html',
  styleUrls: ['./relatorio-caixa.component.scss']
})
export class RelatorioCaixaComponent implements OnInit, OnDestroy {
  barcodeData: string = '8510480708171';
  caixaId;
  deData;
  public caixa = {} as CaixaModel;
  conteudosAny: any[] = [];
  tiposDoc: any[] = [];
  uniqueArray: string[] = [];
  loading = true;
  dateTime;
  showIntervalNrInicial = false;
  intervalNrInicial: string = '-';

  constructor(
    private route: ActivatedRoute,
    private caixaService: CaixaService,
    private conteudoService: ConteudoService,
    private el: ElementRef,
  ) {
    this.route.params.subscribe(params => this.caixaId = params['id']);
    this.deData = CryptoJS.AES.decrypt(decodeURIComponent(this.caixaId), 'pcdoc');
    this.caixaId = JSON.parse(this.deData.toString(CryptoJS.enc.Utf8));

    EventEmitterService.get('isPrintPage').emit(true);
   }

  ngOnInit() {
    this.getDadosCaixa(this.caixaId);
    this.getItensCaixa(this.caixaId);
    this.getConteudoCaixa(this.caixaId);
    const date = new Date();
    this.dateTime = date.toLocaleString('pt-BR');

    

  }

  ngOnDestroy() {
    EventEmitterService.get('isPrintPage').emit(false);
  }

  generateBarCode(rgCaixa: any) {
    const divCanva = this.el.nativeElement.querySelector('#div-canva');
    const canvas = document.createElement('canvas');
    //divCanva.appendChild(canvas);
    // Use bwip-js to draw a barcode on the canvas
    BWIPJS(
      canvas, {
        bcid: 'ean13', // Barcode type (e.g., Code 128)
        text: rgCaixa, // Data to encode
        //scale: 2, // Scaling factor (you can adjust this)
        width: 70,
        height: 20,
      },
      function (err, cvs) {
        if (err) {
          console.error(err);
        } else {
          // Append the canvas to your Angular component template
          divCanva.appendChild(cvs);
        }
      }
    );
  }

  getDadosCaixa(caixaId) {
    this.caixaService.getCaixaUnica(caixaId).subscribe(data => {
      console.log(data);
      this.caixa = data;
      this.loading = false;
      setTimeout(() => {
        this.generateBarCode(this.caixa.rgCaixa);
      }, 1000);
    }, err => {
      console.error(err);
      this.loading = false;
    });
  }

  getConteudoCaixa(caixaId) {
    this.conteudoService.listaItensRelatorio(caixaId).subscribe(data => {
      console.log(data);
      this.tiposDoc = data;
      this.loading = false;
    }, err => {
      console.error(err);
      this.loading = false;
    });
  }

  getItensCaixa (idCaixa) {
    this.conteudoService.listaItens(idCaixa).subscribe(data => {
      this.conteudosAny = data;
      this.getDistinctsTipos(this.conteudosAny);
      this.loading = false;
    }, err => {
      console.error(err);
      this.loading = false;
    });
  }

  getDistinctsTipos(conteudos: any[]) {
    let tipos = conteudos.map(el => el.nodeDicionario.title);
    console.log(tipos);
    
    
    for (const item of tipos) {
        if (!this.uniqueArray.includes(item)) {
            this.uniqueArray.push(item);
        }
    }
  }

  setIntervalNrInicial(event: any) {
    if (event.currentTarget.checked) {
      this.createIntervalNrDocsIniciais();
    } else {
      this.showIntervalNrInicial = false;
    }
  }

  createIntervalNrDocsIniciais() {
    this.showIntervalNrInicial = true;
    if (this.conteudosAny.length > 0) {
      const values = this.conteudosAny.map(obj => obj.numDocInicial).filter(value => value !== null);

      if (values.length > 0) {
        const minValue = Math.min(...values);
        const maxValue = Math.max(...values);

        this.intervalNrInicial = minValue.toString() + ' - ' + maxValue.toString();
        console.log('Menor valor:', minValue); // 3
        console.log('Maior valor:', maxValue); // 20
      } else {
        this.intervalNrInicial = '-';
      }
    } else {
      this.intervalNrInicial = '-';
    }
  }

}



// WEBPACK FOOTER //
// /app/src/app/components/caixa/relatorio-caixa/relatorio-caixa.component.ts